module.exports = __webpack_public_path__ + "img/banner.8de2ccd1.png";